import React from 'react';

const TaskCheckBox = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8047 3.52849C14.0651 3.78884 14.0651 4.21095 13.8047 4.4713L8.47141 9.80463C8.21106 10.065 7.78895 10.065 7.5286 9.80463L5.5286 7.80463C5.26825 7.54428 5.26825 7.12217 5.5286 6.86182C5.78895 6.60147 6.21105 6.60147 6.4714 6.86182L8 8.39042L12.8619 3.52849C13.1223 3.26814 13.5444 3.26814 13.8047 3.52849Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3.33822C3.82319 3.33822 3.65362 3.40845 3.5286 3.53348C3.40357 3.6585 3.33333 3.82807 3.33333 4.00488V12.0049C3.33333 12.1817 3.40357 12.3513 3.5286 12.4763C3.65362 12.6013 3.82319 12.6715 4 12.6715H12C12.1768 12.6715 12.3464 12.6013 12.4714 12.4763C12.5964 12.3513 12.6667 12.1817 12.6667 12.0049V8.00488C12.6667 7.63669 12.9651 7.33822 13.3333 7.33822C13.7015 7.33822 14 7.63669 14 8.00488V12.0049C14 12.5353 13.7893 13.044 13.4142 13.4191C13.0391 13.7942 12.5304 14.0049 12 14.0049H4C3.46957 14.0049 2.96086 13.7942 2.58579 13.4191C2.21071 13.044 2 12.5353 2 12.0049V4.00488C2 3.47445 2.21071 2.96574 2.58579 2.59067C2.96086 2.2156 3.46957 2.00488 4 2.00488H10C10.3682 2.00488 10.6667 2.30336 10.6667 2.67155C10.6667 3.03974 10.3682 3.33822 10 3.33822H4Z"
      fill="currentColor"
    />
  </svg>
);

export default TaskCheckBox;
